export default {"src":"/_next/static/media/docs.8a3b5bd2.svg","height":15,"width":15};